import React, { memo } from "react";
import Accordion from 'react-bootstrap/Accordion';

const Faqs = ({ faq_data }) => {

    return (
        <>
            <div className="faqwrppr mb-4">
                <h3>FAQ About {faq_data?.page_name} </h3>
                <Accordion>
                    {
                       faq_data && Object.entries(faq_data).length > 0 && faq_data.faq_schema?.mainEntity
                        && faq_data.faq_schema.mainEntity.map((value, key) => {
                            return (
                                <>
                                    <Accordion.Item eventKey={`${key}`} key={key}>
                                        <Accordion.Header as="h4">{value.question}</Accordion.Header>
                                        <Accordion.Body>
                                            {
                                                value.answer
                                            }
                                        </Accordion.Body>
                                    </Accordion.Item>
                                </>
                            )
                        })
                    }
                </Accordion>
            </div>
        </>
    );
}

export default memo(Faqs);